import React from 'react';
import KycMainScreen from '../../../components/Liveliness/KycMainScreen';
const Permissions = ({ section, subSection }) => {
  return <KycMainScreen section={section} subSection={subSection} />;
};

export default Permissions;
